import { Action } from 'redux';
import {  
  IAuditLog,
} from '../../services';

export interface IAuditState {
  loading?: boolean;
  auditLog?: IAuditLog;   
  exceptionMessage?: string;
  isPosAuditSuccess?: boolean;
}

export enum AuditActionEnum { 
  PostAudit = '@@Audit/POST_Audit',
  PostAuditSuccess = '@@Audit/POST_AuditSuccess',
  PostAuditFailed = '@@Audit/POST_AuditFailed'
}

export interface IPostAuditAction
  extends Action<typeof AuditActionEnum.PostAudit> {
  state?: IAuditState;
}

export interface IPostAuditSuccessAction
  extends Action<typeof AuditActionEnum.PostAuditSuccess> {
  state?: IAuditState;
}

export interface IPostAuditFailedAction
  extends Action<typeof AuditActionEnum.PostAuditFailed> {
  state?: IAuditState;
}

export type AuditActions =
  | IPostAuditAction
  | IPostAuditSuccessAction
  | IPostAuditFailedAction
